import type { BookingEventRevenueItemDto } from '../Types/bookingEventReport.types';

export const formatBookingCurrency = (value: number, currency?: string | null): string =>
  `${value.toLocaleString('pl-PL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency?.trim().toUpperCase() || 'PLN'}`;

export const formatBookingExchangeRate = (rate: number | null | undefined): string =>
  rate != null
    ? rate.toLocaleString('pl-PL', { minimumFractionDigits: 4, maximumFractionDigits: 4 })
    : '—';

const isForeignRevenueItem = (item: BookingEventRevenueItemDto): boolean =>
  item.exchangeRate != null || (item.currency?.trim().toUpperCase() || 'PLN') !== 'PLN';

export const hasForeignRevenue = (items: BookingEventRevenueItemDto[]): boolean =>
  items.some(isForeignRevenueItem);

export const formatRevenueAmountPln = (item: BookingEventRevenueItemDto): string => {
  if (item.amountPln != null) return formatBookingCurrency(item.amountPln);
  return isForeignRevenueItem(item) ? '—' : formatBookingCurrency(item.amount);
};
